'use client';

import { HTMLProps, useCallback } from 'react';

import { format } from 'date-fns';

import { Button } from '../Button';

import { Calendar } from './Calendar';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';

type DatePickerProps = Omit<HTMLProps<HTMLInputElement>, 'type' | 'value' | 'value' | 'onChange'> & {
  buttonText?: string;
  disablePastDates?: boolean;
  value?: Date | null;
  onChange: (date: Date | null) => void;
};

export function DatePicker({
  disablePastDates,
  buttonText = 'Pick a date',
  value,
  onChange,
  ...props
}: DatePickerProps) {
  const disabled = disablePastDates ? { before: new Date() } : false;

  const onSelect = useCallback((date: Date | undefined) => onChange(date || null), [onChange]);

  return (
    <>
      <input {...props} type="hidden" value={value ? value.toISOString() : ''} />
      <Popover>
        <PopoverTrigger asChild>
          <Button variant={'outlined'}>{value ? format(value, 'PPP') : <span>{buttonText}</span>}</Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            disabled={disabled}
            mode="single"
            selected={value || undefined}
            onSelect={onSelect}
            required={false}
          />
        </PopoverContent>
      </Popover>
    </>
  );
}
